import { useEffect, useState } from "react";
import usePaginator from "../../../theme/Component/usePaginator";
import { Singleton } from "../../../../core/services/Singleton";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { _single } from "../../../../core/services/dataBean/EntityCatalog";
import { toast } from "react-toastify";
import { BasicTable, MASK_MONEY, MASK_NUMBER } from "../../../theme/Component/BasicTable";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { Modal } from "../../../theme/Component/Modal";
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { _BackUpVersion } from "../../../../core/services/dataBean/EntityCatalogVdos";
import { FileService } from "../../../../core/services/FileService";
import { AccountEditor } from "../../../editor/AccountEditor";
import { YearSelector } from "../../../../core/shared/inputs/YearSelector";
import { MonthConstantsEditor } from "../../../RemoteAbstractAction/editors/MonthConstantsEditor";
import { DocumentStorageEditor } from "../DocumentStorageEditor";
import { BasicButton } from "../../../theme/Component/BasicButton";
import { BackupTypeSelect } from "./BackupTypeSelect";




export const DocumentVersionBackupCatalog = () => {

    const BackUpVersion = useDataBean(_BackUpVersion);
    const [funcionario, setFuncionario] = useState<number>(null);
    const [year, setyear] = useState<number>(_single.getCurrenYear())
    const [month, setmonth] = useState<number>(null)
    const [doc, setDoc] = useState<number>(null)
    const [type, setType] = useState<number>(0)
    const single = Singleton.getInstance();
    const [lista, setLista] = useState<any>([]);
    const fileService = new FileService();
    const [modalinfo, setModalinfo] = useState<any>({ name: 'Información', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalhistorial, setModalhistorial] = useState<any>({ name: 'Historial', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalcerti, setModalcerti] = useState<any>({ name: 'Certificaciones', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalref, setModalref] = useState<any>({ name: 'Referencias', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modaldoc, setModaldoc] = useState<any>({ name: 'Documento', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modal, setModal] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: '', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const [Account, setAccount] = useState<any>(null)
    const paginador = usePaginator();
    useEffect(() => {
        getLista();
    }, [paginador.page])
    const getLista = () => {

        BackUpVersion.instance.getDocumentVersionBackupCatalog(funcionario, year, month, doc, type, paginador.page, 15).then(
            (resp: any) => {
                if (resp) {
                    let tmp = resp.List;
                    tmp.forEach((element: any) => {
                        if (element.DataBeanProperties.MediaContext) {
                            element.DataBeanProperties.URL = ` <a href="${fileService.getUrlFile(element.DataBeanProperties.MediaContext, element.DataBeanProperties.Media)}" target='_blank'>DESCARGAR DOCUMENTO</a>`
                        } else {
                            element.DataBeanProperties.URL = "Sin Documento";
                        }
                    });
                    console.log(tmp)
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * 15);
                    paginador.setRegiPerPage(15);
                    setLista(tmp);
                }

            }
        )

    }

    const create = () => {
        BackUpVersion.setBean({
            // IDAccount: AccountResume.bean.IDAccount,
            State: 1,
            IDEmployee: _single.getAccountID(),

        });
        setModal({ ...modal, "view": true });
    }

    const editaItem = () => {
        //console.log(Project.bean);
        BackUpVersion.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }
    const deleteItem = () => {
        BackUpVersion.bean.State = 2;
        //console.log(Project.bean);
        editaItem();
        setModalC({ ...modalC, "view": false });

    }




    const head = [
        { title: 'ID', property: 'IDDocumentVersionBackup', visible: true },
        { title: 'Tipo', property: 'TypeName', visible: true },
        { title: 'Usuario Moficia', property: 'EmployeeName', visible: true },
        { title: 'Tipo Documento', property: 'Mnemonic', visible: true },
        { title: 'Consecutivo', property: 'Consecutive', visible: true },
        { title: 'Fecha Documento', property: 'DocumentDate', visible: true },
        { title: 'Fecha Actualizada', property: 'NewUpdateDate', visible: true },
        { title: 'Documento', property: 'URL', visible: true },
        { title: 'Observaciones', property: 'Description', visible: true },
        { title: 'Fecha Actualización', property: 'Since', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },


        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <BasicPage titulo="Eventos y Notificaciones en Documentos">
            <div className="row">
                <div className="col-md-4">
                    <AccountEditor idAccount={funcionario} onChange={(e) => { setFuncionario(e.IDAccount) }} label="Tercero" />
                </div>
                <div className="col-md-4">
                    <YearSelector value={year} tittle="Año" onChange={(e) => { setyear(e) }} />
                </div>
                <div className="col-md-4">
                    <MonthConstantsEditor idSelect={month} onChange={(e) => { setmonth(e) }} label="Mes" name="" />
                </div>
                <div className="col-md-4">
                    <DocumentStorageEditor onChange={(e) => { setDoc(e.IDDocument) }} label="Documento" />
                </div>
                <div className="col-md-4">
                    <BackupTypeSelect idSelector={type} onChange={(e) => { setType(e) }} />
                </div>
                <div className="col-md-4 mt-4 p-2">
                    <BasicButton icon="ri-add-circle-line" clase="primary" eventClick={getLista}>
                        Buscar
                    </BasicButton>
                </div>
                <div className="col-md-12">

                    <BasicTable body={lista} head={head} rowSet={BackUpVersion.setBean} pageTop={paginador.page} next={paginador.next} back={paginador.back} records={paginador} customRows={15}></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <>
                            <div className="row">

                            </div>
                        </>
                    </Modal>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}